import { render } from "./ChooseStore.vue?vue&type=template&id=531fb6cf&scoped=true"
import script from "./ChooseStore.vue?vue&type=script&lang=js"
export * from "./ChooseStore.vue?vue&type=script&lang=js"

import "./ChooseStore.vue?vue&type=style&index=0&id=531fb6cf&scoped=true&lang=scss"

import exportComponent from "/home/scotty/git/staging_pos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-531fb6cf"]])

export default __exports__